import { useDispatch } from 'react-redux';
import type { AppDispatch } from 'src/store';

/**
 *
 */
export default function useAppDispatch(): AppDispatch {
  return useDispatch<AppDispatch>();
}
